import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { ContractorSearchInterfacePropsType } from '../..';
import { LogoSvg } from '../../assets/Logo.svg';

const { tablet, mobile } = mediaQueries();

type HeaderPropsType = ContractorSearchInterfacePropsType;

export const Header = (props: HeaderPropsType) => {
  return (
    <div
      css={css`
        max-width: 1000px;
        margin-inline: auto;
        padding: 8px 1em;
      `}
    >
      <div
        css={css`
          font-size: 0;
          width: 102px;

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            width: ${setAutomaticDesignBasedSize(102, 96)};
          `)}
        `}
      >
        <LogoSvg />
      </div>
    </div>
  );
};
